/**
 * 事件监听服务
 *
 * @export
 * @param {Node} node
 * @param {string} event
 * @param {EventHandler} handler
 * @param {boolean} [capture]
 * @returns
 */
export default function (node, event, handler, capture) {
    node.addEventListener(event, handler, capture);
    return {
        remove: function () {
            node.removeEventListener(event, handler, capture);
        },
    };
}
//# sourceMappingURL=addEventListener.js.map